(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairExpositorsController', PhysicalFairExpositorsController)

    PhysicalFairExpositorsController.$inject = ['SellerService' ,'ExpoService', 'CitiesByExpoService', 'PhysicalFairService', '$timeout', '$scope','$uibModal'];


    function PhysicalFairExpositorsController(SellerService, ExpoService, CitiesByExpoService, PhysicalFairService, $timeout, $scope,$uibModal) {
        var vm = this;

        vm.dateExpoA = {};
        vm.dateExpoB = {};

        vm.datePicker = {startDate: moment(), endDate: moment(), range:[]};
        vm.optionsDatepickerA = {};
        vm.optionsDatepickerB = {};
        vm.typeOfRangeSelected   = {name:'By date'};
        vm.typeOfRange           = [
                                        {name:'By date'}
                                        // {name:'By day'}
                                    ];

        vm.data                  = [];
        vm.dataGraphType         = [];
        vm.dataGraphCountry      = [];
        vm.registrationFlag      = false;

        vm.flagForViewGraph      = false;
        vm.expoA;
        vm.expoASelected;
        vm.cityASelected;
        vm.cityA;
        vm.expoDatesA;

        vm.expoB;
        vm.expoBSelected;
        vm.cityBSelected;
        vm.cityB;
        vm.expoDatesB;

        vm.seller;
        vm.sellerSelected;

        vm.dateRangeA             = {};
        vm.dateRangeB             = {};

        vm.selectExpo            = selectExpo;
        vm.selectCitiesByExpo    = selectCitiesByExpo;
        vm.getByFilter           = getByFilter;
        vm.getSellers            = getSellers;
        vm.selectedCity          = selectedCity;
        vm.openInformation       = openInformation;


        function activate() {
            vm.selectExpo();
            vm.getSellers();
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                    vm.expoA = response.data;
                    vm.expoB = response.data;
            }).catch(function(err) {

            });
        }

        function getDateOfExpo (expo_id) {
            ExpoService.getDateOfExpo(expo_id).then(function(response){
                    vm.expoA = response.data;
                    vm.expoB = response.data;
            }).catch(function(err) {

            });
        }

        function selectCitiesByExpo (type) {
            var params = [];

            if(type === 'A') {
                vm.cityASelected = [];
                vm.dateRangeA = {};
                params['expo_id']  = vm.expoASelected.id;
                params['city_id']  = null;
                ExpoService.getDateOfExpo(params).then(function(response){
                    var start;
                    var end;
                    /* FIX ME: I'M ALWAYS ADDING A DAY IN DATES DATABASE COMES*/
                    vm.dateRangeA = {startDate: null, endDate: null};
                    start = new Date(response.data[0].startDate+' 00:00:00');
                    end = new Date(response.data[0].endDate+' 00:00:00');

                    /* SET (START AND END B) FOR FILTER BY TYPE RANGE = 'By day' */
                    vm.startA = moment.utc(start).subtract(30, 'days');
                    //vm.endA   = moment.utc(end).subtract(1, 'days');
                    vm.endA   = moment.utc(end);

                            $timeout(function () {
                                vm.optionsDatepickerA = {
                                    ranges: {
                                        '4 weeks before': [moment(start).subtract(4, 'weeks'), moment(end)],
                                        '6 weeks before': [moment(start).subtract(6, 'weeks'), moment(end)],
                                        '10 weeks before': [moment(start).subtract(10, 'weeks'), moment(end)],
                                        '20 weeks before': [moment(start).subtract(20, 'weeks'), moment(end)],
                                        '30 weeks before': [moment(start).subtract(30, 'weeks'), moment(end)]
                                    },
                                    showCustomRangeLabel: false,
                                    alwaysShowCalendars: false
                                };
                             });
                });
            } else {
                vm.cityBSelected = [];
                params['expo_id']  = vm.expoBSelected.id;
                params['city_id']  = null;
                vm.dateRangeB = {startDate: null, endDate: null};
                ExpoService.getDateOfExpo(params).then(function(response){
                    var start;
                    var end;
                    vm.dateRangeB = {};
                    /* FIX ME: I'M ALWAYS ADDING A DAY IN DATES DATABASE COMES*/
                    start = new Date(response.data[0].startDate+' 00:00:00');
                    end = new Date(response.data[0].endDate+' 00:00:00');
                    /* SET (START AND END B) FOR FILTER BY TYPE RANGE = 'By day' */
                    vm.startB = moment.utc(start).subtract(30, 'days');
                    //vm.endB   = moment.utc(end).subtract(1, 'days');
                    vm.endB   = moment.utc(end);
                    $timeout(function () {
                        vm.optionsDatepickerB = {
                            ranges: {
                                '4 weeks before': [moment(start).subtract(4, 'weeks'), moment(end)],
                                '6 weeks before': [moment(start).subtract(6, 'weeks'), moment(end)],
                                '10 weeks before': [moment(start).subtract(10, 'weeks'), moment(end)],
                                '20 weeks before': [moment(start).subtract(20, 'weeks'), moment(end)],
                                '30 weeks before': [moment(start).subtract(30, 'weeks'), moment(end)]
                            },
                            showCustomRangeLabel: false,
                            alwaysShowCalendars: false
                        };
                    },0);
                });
            }
            CitiesByExpoService.getCities(params['expo_id']).then(function(response){
                if(type === 'A')
                    vm.cityA = response.data;
                else
                    vm.cityB = response.data;
            }).catch(function(err) {

            });
            //$scope.$apply();
        }

        function selectedCity (type) {
            var params = [];

            if(type === 'A') {
                params['expo_id']  = vm.expoASelected.id;
                params['city_id']  = vm.cityASelected.id;
                vm.dateRangeA = {startDate: null, endDate: null};
                ExpoService.getDateOfExpo(params).then(function(response){
                    var start;
                    var end;
                    vm.dateRangeA = {};
                    /* FIX ME: I'M ALWAYS ADDING A DAY IN DATES DATABASE COMES*/
                    start = new Date(response.data[0].startDate);
                    end = new Date(response.data[0].endDate);
                    /* SET (START AND END B) FOR FILTER BY TYPE RANGE = 'By day' */
                    vm.startA = moment.utc(start).subtract(30, 'days');
                    //vm.endA   = moment.utc(end).subtract(1, 'days');
                    vm.endA   = moment.utc(end);

                    // vm.optionsDatepickerA = {
                    //     ranges: {
                    //         'Today': [moment(), moment()],
                    //         '1 day before': [moment(start).subtract(1, 'days'), moment(end)],
                    //         '2 days before': [moment(start).subtract(2, 'days'), moment(end)],
                    //         '3 days before': [moment(start).subtract(3, 'days'), moment(end)],
                    //         '4 days before': [moment(start).subtract(4, 'days'), moment(end)],
                    //         '6 days before': [moment(start).subtract(6, 'days'), moment(end)],
                    //         '7 days before': [moment(start).subtract(7, 'days'), moment(end)],
                    //         '8 days before': [moment(start).subtract(8, 'days'), moment(end)],
                    //         '9 days before': [moment(start).subtract(9, 'days'), moment(end)],
                    //         '10 days before':[moment(start).subtract(10, 'days'), moment(end)],
                    //         '3 weeks before': [moment(start).subtract(3, 'weeks'),moment(end)],
                    //         '4 weeks before': [moment(start).subtract(4, 'weeks').startOf('month'),moment(end)]
                    //     }
                    // };
                    $timeout(function () {
                                vm.optionsDatepickerA = {
                                    ranges: {
                                        '4 weeks before': [moment(start).subtract(4, 'weeks'), moment(end)],
                                        '6 weeks before': [moment(start).subtract(6, 'weeks'), moment(end)],
                                        '10 weeks before': [moment(start).subtract(10, 'weeks'), moment(end)],
                                        '20 weeks before': [moment(start).subtract(20, 'weeks'), moment(end)],
                                        '30 weeks before': [moment(start).subtract(30, 'weeks'), moment(end)]
                                    },
                                    showCustomRangeLabel: false,
                                    alwaysShowCalendars: false
                                };
                        },0);
                });
            } else {
                params['expo_id']  = vm.expoBSelected.id;
                params['city_id']  = vm.cityBSelected.id;
                vm.dateRangeB = {startDate: null, endDate: null};
                ExpoService.getDateOfExpo(params).then(function(response){
                    var start;
                    var end;
                    vm.dateRangeB = {};
                    start = new Date(response.data[0].startDate);
                    end = new Date(response.data[0].endDate);
                    /* SET (START AND END B) FOR FILTER BY TYPE RANGE = 'By day' */
                    vm.startB = moment.utc(start).subtract(30, 'days');
                    //vm.endB   = moment.utc(end).subtract(1, 'days');
                    vm.endB   = moment.utc(end);

                    // vm.optionsDatepickerB = {
                    //     ranges: {
                    //         'Today': [moment(), moment()],
                    //         '1 day before': [moment(start).subtract(1, 'days'), moment(end)],
                    //         '2 days before': [moment(start).subtract(2, 'days'), moment(end)],
                    //         '3 days before': [moment(start).subtract(3, 'days'), moment(end)],
                    //         '4 days before': [moment(start).subtract(4, 'days'), moment(end)],
                    //         '6 days before': [moment(start).subtract(6, 'days'), moment(end)],
                    //         '7 days before': [moment(start).subtract(7, 'days'), moment(end)],
                    //         '8 days before': [moment(start).subtract(8, 'days'), moment(end)],
                    //         '9 days before': [moment(start).subtract(9, 'days'), moment(end)],
                    //         '10 days before':[moment(start).subtract(10, 'days'), moment(end)],
                    //         '3 weeks before': [moment(start).subtract(3, 'weeks'),moment(end)],
                    //         '4 weeks before': [moment(start).subtract(4, 'weeks').startOf('month'),moment(end)]
                    //     }
                    // };
                    $timeout(function () {
                        vm.optionsDatepickerB = {
                            ranges: {
                                '4 weeks before': [moment(start).subtract(4, 'weeks'), moment(end)],
                                '6 weeks before': [moment(start).subtract(6, 'weeks'), moment(end)],
                                '10 weeks before': [moment(start).subtract(10, 'weeks'), moment(end)],
                                '20 weeks before': [moment(start).subtract(20, 'weeks'), moment(end)],
                                '30 weeks before': [moment(start).subtract(30, 'weeks'), moment(end)]
                            },
                            showCustomRangeLabel: false,
                            alwaysShowCalendars: false
                        };
                    },0);
                });
            }
           // $scope.$apply();
        }

        function getSellers() {
            SellerService.getAll().then(function(response){
                vm.seller = response.data;
                if(vm.seller.length === 1 && vm.seller[0].selected === 1){
                    vm.sellerSelected = vm.seller[0];
                }
            }).catch(function(err) {
            });
        }

        function getByFilter() {
            vm.registrationFlag = false;
            vm.query = {};
            // vm.query['dateRangeStartA'] = moment(vm.dateRangeA.startDate).format('YYYY-MM-DD');
            // vm.query['dateRangeEndA']   = moment(vm.dateRangeA.endDate).format('YYYY-MM-DD');
            // vm.query['dateRangeStartB'] = moment(vm.dateRangeB.startDate).format('YYYY-MM-DD');
            // vm.query['dateRangeEndB']   = moment(vm.dateRangeB.endDate).format('YYYY-MM-DD');
            if(vm.typeOfRangeSelected.name == 'By day') {
                vm.query['dateRangeStartA'] = moment(vm.startA).format('YYYY-MM-DD');
                vm.query['dateRangeEndA']   = moment(vm.endA).format('YYYY-MM-DD');
                vm.query['dateRangeStartB'] = moment(vm.startB).format('YYYY-MM-DD');
                vm.query['dateRangeEndB']   = moment(vm.endB).format('YYYY-MM-DD');
            } else {
                vm.query['dateRangeStartA'] = moment.utc(vm.dateRangeA.startDate).format('YYYY-MM-DD');
                vm.query['dateRangeEndA']   = moment.utc(vm.dateRangeA.endDate).format('YYYY-MM-DD');
                vm.query['dateRangeStartB'] = moment.utc(vm.dateRangeB.startDate).format('YYYY-MM-DD');
                vm.query['dateRangeEndB'] = moment.utc(vm.dateRangeB.endDate).format('YYYY-MM-DD');
            }

            if(typeof vm.cityASelected !== 'undefined' && typeof vm.cityBSelected !== 'undefined') {
                vm.query['cityA']   = vm.cityASelected.id;
                vm.query['cityB']   = vm.cityBSelected.id;
            }
            if(typeof vm.sellerSelected !== 'undefined' && typeof vm.sellerSelected !== 'undefined') {
                vm.query['seller']   = vm.sellerSelected.id;
            }
            vm.query['expoA'] = vm.expoASelected.id;
            vm.query['expoB'] = vm.expoBSelected.id;
            PhysicalFairService.getExhibitorsRegistrationComparative(vm.query).then(function(response){
                vm.registrationFlag = true;
                vm.registrations = response.data;
            }).catch(function(err) {
            });
            PhysicalFairService.getByFilterExpositors(vm.query).then(function(response){
                vm.data = response.data;
            }).catch(function(err) {
            });
            PhysicalFairService.getExpositorsByType(vm.query).then(function(response){
                vm.dataGraphType = response.data;
            }).catch(function(err) {
            });

            PhysicalFairService.getExpositorsByCountry(vm.query).then(function(response){
                vm.dataGraphCountry = response.data;
            }).catch(function(err) {
            });

            vm.flagForViewGraph = true;
        }


        function openInformation(exhibitor) {
            vm.exhibitor = exhibitor;
            vm.modalInformation = $uibModal.open({
                templateUrl: 'templates/physicalfairs/reports/expositors/show.modal.html',
                scope: $scope,
                resolve: {
                    exhibitor: function() {
                        return vm.exhibitor;
                    }
                }
            });
        }
        activate();

    }

})();